
<ion-header>
    <ion-toolbar>
        <ion-title>
            Test Page
        </ion-title>
    </ion-toolbar>
</ion-header>
<ion-content>

    <img [src]="context">
</ion-content>